import { render, staticRenderFns } from "./jurisdictionRouter.vue?vue&type=template&id=188971fd&"
import script from "./jurisdictionRouter.vue?vue&type=script&lang=js&"
export * from "./jurisdictionRouter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports